import { isEmpty } from 'lodash'

export const onlyLetters = (value) => {
  if (isEmpty(value)) return ''
  return value.replace(/[^a-zA-Z0-9 ]/g, '')
}

export default onlyLetters
